<template>
    <div>
      <b-sidebar 
        id="sidebarProject"
        backdrop
        shadow
        title="Versions"
        bg-variant="msstream"
        text-variant="white"
        > 
          <b-list-group :key="timelineKey">
            <span v-for="(version, index) in versionsList" :key="index">

            <b-list-group-item v-if="version.versionGen != projectVersion && !version.deleted " style="color:white; background-color:#2a5d77; border: 1px solid #2F90B0">
              <div class="d-flex w-100 justify-content-between">
                <h6 class="mb-2"><strong>Version {{version.versionGen}}</strong></h6> 
                <small class="divNameP100" :title="'Version creator: '+version.publisher">
                  By {{version.publisher}}
                </small>
                <small title="Version creation date">
                  <font-awesome-icon :icon="['fas', 'calendar-minus']" />
                  {{version.date}}
                </small>
              </div>
              <p class="mb-2 text-break" style="line-height:normal">
                <small>{{version.description}}</small>
              </p>
              <div style="border-bottom:1px solid #dfdfdf; margin: 10px 30px"></div>
              <b-row class="align-items-center">
                <b-col cols="9" :title="'From video: '+version.videoTitle">
                  <small class="text-break">
                    <font-awesome-icon :icon="['fas', 'film']" />
                    {{version.videoTitle}}
                  </small>
                </b-col>
                <b-col cols="3" style="margin-right:0px; padding:0px; text-align:right">
                  <b-button  size="sm" style="margin-right:5px" variant="msstreamblue" @click="getVersionVideo(version.versionGen)" :title="'Load version '+version.versionGen">
                    <b-icon icon="arrow-right-circle-fill" ></b-icon>
                  </b-button>              
                  <b-button  size="sm" variant="quanteec" @click="deleteVersion(version.versionGen)" v-if="numberVersion > 1" :title="'Delete version '+version.versionGen">
                    <font-awesome-icon :icon="['fas', 'trash']" />
                  </b-button>
                </b-col>
              </b-row>
            </b-list-group-item>

            <b-list-group-item v-if="version.versionGen == projectVersion && !version.deleted" active style="color:#2a5d77; border: 2px solid #14BF98; background-color:white">
              <div class="d-flex w-100 justify-content-between">
                <h6 class="mb-2"><strong>Version {{version.versionGen}}</strong></h6> 
                <small class="divNameP100" :title="'Version creator: '+version.publisher">
                  By {{version.publisher}}
                </small>
                <small title="Version creation date">
                  <font-awesome-icon :icon="['fas', 'calendar-minus']" />
                  {{version.date}}
                </small>
              </div>
              <b-row class="mb-2 text-break" style="line-height:normal" title="Version description">
                <b-button
                  variant="emptyB"
                  style="text-align: justify; cursor:pointer"
                  title="Version description, click to modify"
                  v-if="
                    !updateVersionDescription &&
                    (userRole === 'owner' || userRole === 'admin')
                  "
                  @click="
                    updateVersionDescription = !updateVersionDescription;
                    newVersionDescription = version.description;
                    selectedVersion = version;
                  "
                >
                  <small>
                    <span v-if="version.description === null || version.description === undefined" style="font-color:gray">No description</span>
                    <span v-else>{{ version.description }}</span>
                  </small>
                </b-button>
                <small
                  title="Project description"
                  style="margin:0px 15px"
                  v-if="
                    !updateVersionDescription &&
                    (userRole === 'viewer' || userRole === 'editor')
                  "
                >
                  {{ version.description }}
                </small>
                <b-form-group
                  style="text-align: justify; margin:0px; padding:5px 10px"
                  v-if="updateVersionDescription"
                  @submit.prevent="newVersionDescription"
                >
                  <b-input-group>
                    <b-form-textarea 
                      placeholder="Enter version description here"
                      rows="2"
                      v-model="newVersionDescription"
                      style="font-size: small; min-height:50px; min-width:210px"
                    >
                    </b-form-textarea>
                    <b-button variant="bordered" @click="updateVersionDescriptionFct">
                      <small><font-awesome-icon class="pointerEltSB" style="color: #14bf98" :icon="['fas', 'check']" /></small>
                    </b-button>
                    <b-button variant="borderedx" @click="cancelVersionDescription">
                      <small><font-awesome-icon class="pointerEltSB" style="color: red" :icon="['fas', 'times']" /></small>
                    </b-button>
                  </b-input-group>
                </b-form-group>
              </b-row>
    
              <div style="border-bottom:1px solid #2a5d77; margin: 10px 30px"></div>
              <b-row class="align-items-center">
                <b-col cols="9" :title="'From video: '+version.videoTitle">
                  <small class="text-break">
                    <font-awesome-icon :icon="['fas', 'film']" />
                    {{version.videoTitle}}
                  </small>
                </b-col>
                <b-col cols="3" style="margin-right:0px; padding:0px; text-align:right">
                  <b-button  style="margin-right:10px; cursor:default" size="sm" variant="green2" :title="'Currently loaded version: v'+version.versionGen">
                    <font-awesome-icon :icon="['fas', 'dice-one']" />
                  </b-button>              
                  <b-button  size="sm" variant="quanteec" @click="deleteVersion(version.versionGen)" v-if="numberVersion > 1">
                    <font-awesome-icon :icon="['fas', 'trash']" />
                  </b-button>
                </b-col>
              </b-row>

            </b-list-group-item>
        
            <b-list-group-item v-if="version.deleted" style="color: #f2f2f2; border: 1px solid #484a46; background-color: gray">
              <div class="d-flex w-100 justify-content-between">
                <h6 class="mb-1">Version {{version.versionGen}}</h6>
              </div>
              <small>
                This version has been permanently deleted
              </small>
            </b-list-group-item>
          
          </span>

        </b-list-group>   
          
        <div class="text-center" style="margin-top:20px" v-if="userRole === 'owner' || userRole === 'admin' ">
          <b-button variant="msstreamblue" style="width:90%" v-b-modal.modal-new-version>
            New version&nbsp;
            <b-icon icon="plus-circle" />
          </b-button>
        </div>  

        <div class="text-center" style="margin-top:20px; margin-bottom:20px" v-if="userRole === 'owner'">
          <b-button variant="quanteec" style="width:90%" v-b-modal.delete-project>
            Delete project&nbsp;
            <font-awesome-icon :icon="['fas', 'trash']" />
          </b-button>
        </div>            

      </b-sidebar>

      <b-modal
        id="modal-new-version"
        ref="modal"
        title="Create a new version"
        @ok="addVersion"
        @show="loadVideos"
        size="xl"
        :busy="busyModal"
        :no-close-on-backdrop="noCloseBackdrop"
        :no-close-on-esc="noCloseEsc"
        :hide-header-close="hideCloseButton"
        >
        <form ref="form" @submit.stop.prevent="handleSubmit" v-if="uploadStarted === false">
        
        <b-form-group
        label="Version description (optional)"
        >
          <b-form-textarea
          id="description-input"
          v-model="versionDescription"
          required
          ></b-form-textarea>
        </b-form-group>

        <b-form-group
        id="input-group-3"
        label="Video*: "
        label-for="input-3"
        :state="versionVideoState"
        invalid-feedback="A video file is required"
        >
          <div style="padding: 10px; border: 1px solid; border-radius:5px">

          Select among existing videos or upload a new one:
          <b-row class="align-items-center" style="margin:10px 0px">
            <b-col>
              <b-form-radio v-model="selectionMode" name="some-radios" value="select"> Existing videos</b-form-radio>
            </b-col>
            <b-col>
              <b-form-radio v-model="selectionMode" name="some-radios" value="upload">Upload a new video</b-form-radio>
            </b-col>
          </b-row>     

            <b-form-file v-if="selectionMode === 'upload'"
            id="input-3"
            v-model="videoFile"
            placeholder="Choose video to upload"
            accept="video/*"
            :state="versionVideoState"
            required
            ></b-form-file>

            <b-form-input v-if="selectionMode === 'select'"
            placeholder="Search among existing videos"
            v-model="searchParams"
            @input="updateVideoList"
            ></b-form-input>

            <div v-if="selectionMode === 'select'" style="margin:10px">
              <small>
                <div v-if="selectedVideo != null">
                  Selected video: <span style="color:#14BF98"> {{this.selectedVideo.title}} -  {{this.selectedVideo.createdDate}}</span>
                </div>
                <div v-if="selectedVideo === null">
                  Selected video: <span style="font-weight:bold"> None</span>
                </div>
              </small>
            </div>
            
            <div v-if="selectionMode === 'select'" style="border: 1px solid #2F90B0">
              <ul 
              id="videoListResult" 
              style="list-style-type: none; padding:0px 10px"
              >
                <li v-for="video in videosForList" :key="video.uuid" style="margin-top:10px" @click="selectVideo(video)">
                  <span v-if="selectedVideo != null && selectedVideo.title === video.title">
                    <div style="border: 1px solid #14BF98; padding:3px">
                      <b-img class="previewImg" style="object-fit:cover; width:10%; max-height:60px" :src="`${baseurl[video.type]}/contents/${(video.encodingStatus === 'segmented') ? 'passthrough' : 'encodings'}/${video.type}/${video.uuid}/thumbnail.jpg`" @error="imgUrlAlt" fluid></b-img> 
                      <small> {{video.title}} - {{video.createdDate}}</small>
                    </div>
                  </span>
                  <span v-else>
                    <b-img class="previewImg" style="object-fit:cover; width:10%; max-height:60px" :src="`${baseurl[video.type]}/contents/${(video.encodingStatus === 'segmented') ? 'passthrough' : 'encodings'}/${video.type}/${video.uuid}/thumbnail.jpg`" @error="imgUrlAlt" fluid></b-img> 
                    <small> {{video.title}} - {{video.createdDate}}</small>
                  </span>
                </li>
              </ul>

              <b-pagination 
              style="font-size:70%"
              v-model="currentPage"
              :total-rows="totalRows"
              :per-page="4"
              aria-controls="videoListResult"
              align="center"
              ></b-pagination>
            </div>
          </div>
        </b-form-group>


<!--
        <b-form-group
        label="Select or upload a video"
        invalid-feedback="A video file is required"
        :state="versionVideoState"
        >

          <b-row>
            <b-col>
              <b-form-radio v-model="selectionMode" name="some-radios" value="upload">Upload a new video</b-form-radio>
            </b-col>
            <b-col>
              <b-form-radio v-model="selectionMode" name="some-radios" value="select">Select a video already existing</b-form-radio>
            </b-col>
          </b-row>
          <b-form-file v-if="selectionMode === 'upload'"
          id="input-3"
          v-model="videoFile"
          placeholder="Upload a video"
          accept="video/*"
          :state="versionVideoState"
          required
          ></b-form-file>
                      
          <b-form-input v-if="selectionMode === 'select'"
          placeholder="Search a video for this version"
          v-model="searchParams"
          @input="updateVideoList"
          >                            
          </b-form-input>

          <div v-if="selectionMode === 'select'" style="margin-top:10px">
            <div v-if="selectedVideo != null">
              Select video : {{this.selectedVideo.title}} -  {{this.selectedVideo.createdDate}}
            </div>
            <div v-if="selectedVideo === null">
              Select video : None
            </div>
          </div>
        </b-form-group>
                      

        <ul 
        id="videoListResult" 
        style="list-style-type: none;"
        v-if="selectionMode === 'select'">
          <li v-for="video in videosForList" :key="video.uuid" style="margin-top:10px" @click="selectVideo(video)">
            <b-img class="previewImg" style="object-fit:cover; width:10%" :src="`${baseurl[video.type]}/contents/${(video.encodingStatus === 'segmented') ? 'passthrough' : 'encodings'}/${video.type}/${video.uuid}/thumbnail.jpg`" @error="imgUrlAlt" fluid></b-img> {{video.title}} - {{video.createdDate}}
          </li>
        </ul>

        <b-pagination v-if="selectionMode === 'select'"
        v-model="currentPage"
        :total-rows="totalRows"
        :per-page="4"
        aria-controls="videoListResult"
        align="center"
        ></b-pagination>
-->
      </form>

      <b-row>
        <b-col cols ="12" v-if="uploadStarted === true">
          <div class="inputCard" v-for="(file2) in files" cols="12" xs="6" md="4" lg="4" v-bind:key="file2.filename">
            <h5 style="margin-top:8px">{{file2.name}}</h5>
            <p><strong>Size:</strong> {{Math.round(file2.size / 1000000)}} MB</p>
            <p v-if="file2.isLoading">Upload in progress...</p>
            <p v-if="file2.isLoadingEnd">Video uploaded.</p>
            <b-progress style="width:100%" v-if="file2.isLoading || file2.isLoadingEnd">
              <b-progress-bar :value="file2.loadingPercent" animated variant="primary">
                {{file2.loadingPercent}}%
              </b-progress-bar>
            </b-progress>              
          </div>
        </b-col>
      </b-row>
      
    </b-modal>        
    
    <b-modal id="delete-project" ref="confirmDelete" hide-footer hide-header>
      <div class="d-block text-center">
        <h3 style="border-bottom:1px solid #2a5d77; padding:10px">
          <font-awesome-icon style="color: red; margin-right:5px" :icon="['fas', 'trash']" />
          Project deletion
        </h3>
      </div>
      <p style="line-height:normal">Please confirm permanent deletion of the project. <br>It cannot be recovered.</p>
      <b-row class="justify-content-around">
        <b-btn
          class="col-md-3 col-5"
          variant="quanteec"
          @click="
            deleteProject();
            hideModal('confirmDelete');
          "
          >
          <font-awesome-icon style="margin-right:5px" :icon="['fas', 'trash']" />
          Delete
        </b-btn>
        <b-btn
          class="col-md-3 col-5"          
          @click="hideModal('confirmDelete')"
          variant="quanteeclg"
          >
          <font-awesome-icon style="margin-right:5px" :icon="['fas', 'times']" />
          Cancel
        </b-btn>
      </b-row>
    </b-modal>


  </div>

</template>

<script>
let moment = require("moment");
import versionManagementService from "@/services/versionsManagement.service.js";
import vireedAnnotationService from "@/services/vireedAnnotation.service.js";
import VideoService from "@/services/video.service.js";
import Swal from "sweetalert2";
import { BASE_READER, EMBED_URL } from "@/services/base-url";
import ProjectService from "@/services/project.service.js"

let Pservice = new ProjectService();
var VideoMethods = new vireedAnnotationService();
var VersionsFunctions = new versionManagementService();
var vService = new VideoService();



export default {
  data() {
    return {
      currentPage:1,
      baseurl: BASE_READER,
      versionsList: [],
      timelineKey: 0,
      dialog: false,
      pVersion: this.$route.params.version || "-1",
      versionVideoState : null,
      videoFile : null,
      versionDescription : null,
      videosList:[],
      searchVideoResult:[],
      searchParams:"",
      selectionMode:"upload",
      selectedVideo:null,
      projectId: this.$route.params.projectId,
      uploadStarted:false,
      files : [],
      newVersionNumber : null,
      busyModal : false,
      noCloseBackdrop:false,
      noCloseEsc:false,
      hideCloseButton:false,
      numberVersion:0,
      updateVersionDescription:false,
      newVersionDescription: "",
      selectedVersion:""
    };
  },
  props: ["projectVersion", "userRole","projectName"],
    methods: {
    showDelete: function (id) {
      
      if (document.getElementById(id) && (this.userRole === "owner" || this.userRole === "admin"))
      {
        document.getElementById(id).style.display = "inline";
      }        
    },
    hideDelete: function (id) {
      if (document.getElementById(id))
        document.getElementById(id).style.display = "none";
    },

    deleteVersion: function (versionGen) {
      this.dialog = true;
      //VersionsFunctions.deleteVersion(this, versionGen, versionVariante);
      Swal.fire({
        title: `Version deletion`,
        html:
          "Please confirm the deletion of version " +
          versionGen +
          " of this project",
        showConfirmButton: true,
        showCancelButton: true,
        confirmButtonText: `Delete`,
      }).then((result) => {
        if (result.isConfirmed) {
          VideoMethods.deleteVersion(this, versionGen, this.$auth.token(), this.$socket);
        }
      });
    },

    hideModal(modal) {
      this.$refs[modal].hide();
    },

    getVersionVideo: function (versionGen) {
      VersionsFunctions.getVersionVideo(this, versionGen);
      this.timelineKey += 1;
      this.$emit("version-changed");
    },

    loadVideos :function()
    {
      vService.getVideosForClient(this.$auth.token())
      .then((response)=>{
        this.videosList = response;
        this.searchVideoResult = this.videosList;
        //for(let video in this.videosList)
        this.videosList.forEach(function(video)
        {
          video.createdDate = moment(
          video.createdAt).format("DD/MM/YY @ HH:mm");
        });
        this.videosList.sort((a, b) => new Date(b.createdAt)-new Date(a.createdAt))

      }).catch((error)=>{
        console.log(error)
      })
    },

    addVersion(bvModalEvt)
    {
      bvModalEvt.preventDefault();
      this.busyModal = true;
      this.noCloseEsc = true;
      this.noCloseBackdrop = true;
      this.hideCloseButton = true;

      if(this.selectionMode === "upload")
      {

        var videos = [];
        videos.push({type: "vod", title: this.videoFile.name, uploadingPercent: 0});
        this.files=[this.videoFile]


        vService.postVideos(videos, this.$auth.token()).then((result) => {
          this.uploadStarted = true;
          let video = result[0]

          Pservice.createVersionUpload(this.$auth.token(), this.projectId, video.video.uuid, this.$auth.getMyUser().username, this.versionDescription)
          .then((response)=>{
            this.newVersionNumber = response.currentVersion;
            this.standby=false;
            this.uploadFiles(result)    
          }).catch((err) => {
            console.log(err)
          })
        }).catch((err) => {
          console.log(err)
        })       
      }
      else if(this.selectionMode === "select"){

        Pservice.createVersionSelection(this.$auth.token(), this.projectId, this.selectedVideo.uuid, this.versionDescription, this.$auth.getMyUser().username)
        .then((response)=>{
          this.standby=false;
          Swal.fire({
            icon: 'success',
            text: 'The version ' + response.currentVersion + ' of the project has been created successfully',
            }).then((result) => {
              this.$router.push("/vireed/" + this.projectId + "/" + response.currentVersion);
              this.$emit('version');
              this.$emit("version-changed")
              
          });        
        }).catch((err) =>{
          console.log(err);
        })
        
      }
    },

    updateVideoList()
    {
      let params = this.searchParams;
      let newSearchResults = this.videosList.filter(v => v.title.toLowerCase().includes(params.toLowerCase()))

      this.searchVideoResult = newSearchResults
    },

    imgUrlAlt(event) {
      event.target.src = `/thumbnail.jpg`;
    },

    selectVideo : function (video)
    {
      this.selectedVideo = video;
    },

    deleteProject : function()
    {
      VideoMethods.deleteProject(this,this.$auth.token(), this.$socket);
    },

    cancelVersionDescription() {
      this.newVersionDescription = "";
      this.updateVersionDescription = false;
    },

    updateVersionDescriptionFct() {
      this.updateVersionDescription = false;
      var body = { description: this.newVersionDescription };
      Pservice.updateVersion(this.$auth.token(), this.projectId, this.projectVersion, body)
      .then(()=>{
        this.selectedVersion.description = this.newVersionDescription
      }).catch(err=>{
        console.log(err)
      })
      /*
      Pservice.updateProject(this.$auth.token(), this.projectId, body).then(
        (res) => {
          if (this.$socket != undefined || this.$socket != null) {
            this.$socket.emit("projectInfoUpdated");
          }
          this.versionDescription = this.newVersionDescription;
        }
      );*/
    },


    uploadFiles(results) {
      var chunkSize = 5 * 1000000;
      this.uploadstarted = true;
      function slice(file, start, end) {
        var slice = file.mozSlice ? file.mozSlice :
                    file.webkitSlice ? file.webkitSlice :
                    file.slice ? file.slice : noop;
        
        return slice.bind(file)(start, end);
      }

      var uploadFile = (video, fileIndex) => {
        let seconds_to_days_hours_mins_secs_str =function(seconds) { 
          var hours    = Math.floor(seconds / (60*60));
              seconds -= hours   * (60*60);
          var minutes  = Math.floor(seconds / (60));
              seconds -= minutes * (60);
          if (minutes < 10 && hours > 0) {
              minutes = "0" + minutes;
          }
          if ((minutes > 0 || hours > 0) && seconds < 10) {
              seconds = "0" + seconds;
          }
          
          return ((0<hours)?(hours+":"):"") + ((0<minutes || hours > 0)?(minutes+":"):"") +seconds+"s";
        }

        return new Promise((done, reject) => {
          self = this;
          self.files[fileIndex].isLoading = true;
          self.files[fileIndex].isLoadingEnd = false;
          self.files[fileIndex].isLoadingError = false;
          self.files[fileIndex].loadingPercent =  0;
          self.files[fileIndex].currentData =  0;
          self.files[fileIndex].currentChunk =  1;
          self.files[fileIndex].startDate =  new Date();
          self.files = self.files.splice(0, self.files.length);

          var sendNextData = function() {
            var start = self.files[fileIndex].currentData;
            var size = self.files[fileIndex].size;
            var end = start + chunkSize;
            var isEnd = false;
            
            if (size - end <= 0) {
              end = size;
              isEnd= true;
            }

            var data = slice(self.files[fileIndex], start, end);
            vService.postChunk(video.video.uuid, self.files[fileIndex].currentChunk, data, self.files[fileIndex].name, isEnd, self.$auth.token()).then(() => {
              if (isEnd) {
                self.files[fileIndex].isLoading = false;
                self.files[fileIndex].isLoadingError = false;
                self.files[fileIndex].isLoadingEnd = true;
                self.files[fileIndex].loadingPercent =  100;
                vService.putVideoById({uploadingPercent: 100, uploadingETA: '0s', lastUploadingFeedbackDate: new Date()}, video.video.uuid, self.$auth.token()).then(() =>{}).catch(err => {});
                self.files = self.files.splice(0, self.files.length);
                
                done();
              } else {
                var start = self.files[fileIndex].currentData += chunkSize;
                self.files[fileIndex].currentChunk += 1
                self.files[fileIndex].loadingPercent =  Math.round(100 * self.files[fileIndex].currentData / self.files[fileIndex].size);

                let currentDate = new Date();
                let currentPercent = self.files[fileIndex].loadingPercent;
                let timeSpentMS = currentDate.getTime() - self.files[fileIndex].startDate.getTime();
                let estimatedEndDuration = Math.round(timeSpentMS * 100 / currentPercent);
                let estimatedEndDate = new Date(self.files[fileIndex].startDate.getTime() + estimatedEndDuration);
                let durationUntilEnd = seconds_to_days_hours_mins_secs_str(Math.round((estimatedEndDate.getTime() - currentDate.getTime()) / 1000))
                vService.putVideoById({uploadingPercent: self.files[fileIndex].loadingPercent, uploadingETA: durationUntilEnd, lastUploadingFeedbackDate: currentDate}, video.video.uuid, self.$auth.token()).then(() =>{}).catch(err => {});
                
                self.files = self.files.splice(0, self.files.length);
                setTimeout(sendNextData, 1);
              }

            }).catch((err) => {
                self.files[fileIndex].isLoading = false;
                self.files[fileIndex].isLoadingEnd = false;
                self.files[fileIndex].isLoadingError = true;
                self.files[fileIndex].loadingPercent =  0;
                self.files = self.files.splice(0, self.files.length);

                done()
            })
          }
          sendNextData();

        })
      }
      var video = results[0];
      var fileIndex = this.files.findIndex((elem) => {return elem.name === video.video.originalname});
      uploadFile(video, fileIndex).then(() => {
        results.shift();
        if (results.length > 0) {
          this.uploadFiles(results);
        } else {
          this.files = [];
          this.uploadStarted = false;
          //document.location.href = document.location.href.split('?uploading=true')[0];
          //this.$router.push('/');
            Swal.fire({
              icon: 'success',
              text: 'The version ' + this.newVersionNumber + ' of the project has been created successfully',
              }).then((result) => {
                this.$router.push("/vireed/" + this.projectId + "/" + this.newVersionNumber);
                this.$emit('version');
                this.$emit("version-changed")
            });
        }
      }).catch((err) => {
        console.log(err);
      })
    },
  },
  computed:
  {
    totalRows ()
    {
      return this.searchVideoResult.length;
    },

    videosForList() {
      return this.searchVideoResult.slice(
        (this.currentPage - 1) * 4,
        this.currentPage * 4,
      );
    },
  },
  beforeMount() {
    VersionsFunctions.getVersionsList(this, this.$auth.token())
  },

    
}
</script>

<style>
.theme--light.v-timeline::before{
    background:white;
}
</style>